import { Store, ActionTree, ActionContext } from 'vuex'
import { State } from './state'
import { StatsDeklaracjeService } from "@/services/stats-deklaracje.service";
import { StatsPobraniaService } from "@/services/stats-pobrania.service";
import { StatsUruchomieniaService } from "@/services/stats-uruchomienia.service";
import { StatsTopService } from "@/services/stats-top.service";
import moment from 'moment';
import _ from 'lodash';
import { loadingStatsTopOperatingSystems } from "@/store/modules/dashboard/mutations";
import { DataTablePaginator } from "@/store/modules/dashboard/types";

export async function getTotalStatsDeklaracje(store: ActionContext<State, any>) {
    store.commit('loadingTotalStatsDeklaracje');

    try {
        const totalStatsDeklaracje = await StatsDeklaracjeService.getTotal();
        store.commit('loadedTotalStatsDeklaracje', {stat: totalStatsDeklaracje.total, updatedAt: totalStatsDeklaracje.updatedAt.date});
        store.dispatch('getTotalStatsDeklaracjeLastYear');
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function refreshTotalStatsDeklaracje(store: ActionContext<State, any>) {
    store.commit('refreshingTotalStatsDeklaracje');
    try {
        const totalStatsDeklaracje = await StatsDeklaracjeService.getTotal(true);
        store.commit('loadedTotalStatsDeklaracje', {stat: totalStatsDeklaracje.total, updatedAt: totalStatsDeklaracje.updatedAt.date});
        store.dispatch('refreshTotalStatsDeklaracjeLastYear');
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getTotalStatsPobrania(store: ActionContext<State, any>) {
    store.commit('loadingTotalStatsPobrania');

    try {
        const totalStatsPobrania = await StatsPobraniaService.getTotal();
        store.commit('loadedTotalStatsPobrania', {stat: totalStatsPobrania.total, updatedAt: totalStatsPobrania.updatedAt.date});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function refreshTotalStatsPobrania(store: ActionContext<State, any>) {
    store.commit('refreshingTotalStatsPobrania');
    try {
        const totalStatsPobrania = await StatsPobraniaService.getTotal(true);
        store.commit('loadedTotalStatsPobrania', {stat: totalStatsPobrania.total, updatedAt: totalStatsPobrania.updatedAt.date});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getTotalStatsUruchomienia(store: ActionContext<State, any>) {
    store.commit('loadingTotalStatsUruchomienia');

    try {
        const totalStatsUruchomienia = await StatsUruchomieniaService.getTotal();
        store.commit('loadedTotalStatsUruchomienia', {stat: totalStatsUruchomienia.total, updatedAt: totalStatsUruchomienia.updatedAt.date});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function refreshTotalStatsUruchomienia(store: ActionContext<State, any>) {
    store.commit('refreshingTotalStatsUruchomienia');
    try {
        const totalStatsUruchomienia = await StatsUruchomieniaService.getTotal(true);
        store.commit('loadedTotalStatsUruchomienia', {stat: totalStatsUruchomienia.total, updatedAt: totalStatsUruchomienia.updatedAt.date});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getTotalStatsDeklaracjeLastYear(store: ActionContext<State, any>) {
    store.commit('loadingTotalStatsDeklaracjeLastYear');

    try {
        const totalStatsDeklaracjeLastYear = await StatsDeklaracjeService.getTotalLastYear();
        store.commit('loadedTotalStatsDeklaracjeLastYear', {stat: totalStatsDeklaracjeLastYear.total, updatedAt: totalStatsDeklaracjeLastYear.updatedAt.date});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function refreshTotalStatsDeklaracjeLastYear(store: ActionContext<State, any>) {
    store.commit('refreshingTotalStatsDeklaracjeLastYear');
    try {
        const totalStatsDeklaracjeLastYear = await StatsDeklaracjeService.getTotalLastYear(true);
        store.commit('loadedTotalStatsDeklaracjeLastYear', {stat: totalStatsDeklaracjeLastYear.total, updatedAt: totalStatsDeklaracjeLastYear.updatedAt.date});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getAggregatedStatsDeklaracje(store: ActionContext<State, any>, forceRefresh: boolean = false) {
    store.commit('loadingAggregatedStatsDeklaracje');

    try {
        const aggregatedStatsDeklaracje = await StatsDeklaracjeService.getAggregatedBetweenDates(moment(store.state.aggregatedStatsDeklaracjeDateTo).subtract(20, "days").format('YYYY-MM-DD'), store.state.aggregatedStatsDeklaracjeDateTo, false, forceRefresh);
        const transformedStats = transformAggregatedStatsDeklaracjeResults(store.state.aggregatedStatsDeklaracjeDateTo, aggregatedStatsDeklaracje.data);
        const dataset = {
            label: 'Obecny rok (zł)', backgroundColor: 'rgba(233,30,99,0.6)',
            borderColor: '#E91E63',
            borderWidth: 1,
            pointBackgroundColor: 'white',
            data: Object.values(transformedStats)
        };
        store.commit('loadedAggregatedStatsDeklaracjeDataset', {stat: dataset, updatedAt: aggregatedStatsDeklaracje.updatedAt.date});
        if (!_.isEmpty(store.state.aggregatedStatsDeklaracjeLastYearDataset)) {
            const datasets = {
                labels: Object.keys(transformedStats),
                datasets: [store.state.aggregatedStatsDeklaracjeDataset, store.state.aggregatedStatsDeklaracjeLastYearDataset]
            };
            store.commit('setAggregatedStatsDeklaracjeDatasets', datasets);
        }
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getAggregatedStatsDeklaracjeLastYear(store: ActionContext<State, any>, forceRefresh: boolean = false) {
    store.commit('loadingAggregatedStatsDeklaracjeLastYear');

    try {
        const aggregatedStatsDeklaracjeLastYear = await StatsDeklaracjeService.getAggregatedBetweenDates(moment(store.state.aggregatedStatsDeklaracjeDateTo).subtract(1, "years").subtract(20, "days").format('YYYY-MM-DD'), moment(store.state.aggregatedStatsDeklaracjeDateTo).subtract(1, "years").format('YYYY-MM-DD'), true, forceRefresh);
        const transformedStats = transformAggregatedStatsDeklaracjeResults(store.state.aggregatedStatsDeklaracjeDateTo, aggregatedStatsDeklaracjeLastYear.data, true)
        const dataset = {
            label: 'Ubiegły rok (zł)',
            backgroundColor: 'rgba(207,216,220,0.6)',
            borderColor: '#CFD8DC',
            borderWidth: 1,
            pointBackgroundColor: 'white',
            data: Object.values(transformedStats)
        };
        store.commit('loadedAggregatedStatsDeklaracjeLastYearDataset', {stat: dataset, updatedAt: aggregatedStatsDeklaracjeLastYear.updatedAt.date});
        if (!_.isEmpty(store.state.aggregatedStatsDeklaracjeDataset)) {
            const datasets = {
                labels: Object.keys(transformedStats),
                datasets: [store.state.aggregatedStatsDeklaracjeDataset, store.state.aggregatedStatsDeklaracjeLastYearDataset]
            };
            store.commit('setAggregatedStatsDeklaracjeDatasets', datasets);
        }
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function loadPreviousAggregatedStatsDeklaracje(store: ActionContext<State, any>) {
    store.commit('loadPreviousAggregatedStatsDeklaracje', moment(store.state.aggregatedStatsDeklaracjeDateTo).subtract(20, "days").format('YYYY-MM-DD'));
    store.dispatch('getAggregatedStatsDeklaracje');
    store.dispatch('getAggregatedStatsDeklaracjeLastYear');
}

export async function loadNextAggregatedStatsDeklaracje(store: ActionContext<State, any>) {
    store.commit('loadNextAggregatedStatsDeklaracje', moment(store.state.aggregatedStatsDeklaracjeDateTo).add(20, "days").format('YYYY-MM-DD'));
    store.dispatch('getAggregatedStatsDeklaracje');
    store.dispatch('getAggregatedStatsDeklaracjeLastYear');
}

export async function refreshAggregatedStatsDeklaracje(store: ActionContext<State, any>) {
    store.commit('refreshingAggregatedStatsDeklaracje');
    store.dispatch('getAggregatedStatsDeklaracje', true);
    store.dispatch('getAggregatedStatsDeklaracjeLastYear', true);
}

function transformAggregatedStatsDeklaracjeResults(aggregatedStatsDeklaracjeDateTo: string, result :any, lastYear: boolean = false) {
    let resTransformed : any = [];
    let year :string = (lastYear) ? moment(aggregatedStatsDeklaracjeDateTo).subtract(1, "year").format('YYYY-MM-DD') : aggregatedStatsDeklaracjeDateTo;
    for(let i: number = 19; i>=0; i--) {
        let dateKey = moment(year).subtract(i, "days").format('YYYY-MM-DD');
        resTransformed[moment(dateKey).format("D MMM")] = (result[dateKey] == undefined) ? 0 : result[dateKey].toFixed(2);
    }
    return resTransformed;
}

export async function getAggregatedStatsUruchomienia(store: ActionContext<State, any>, forceRefresh: boolean = false) {
    store.commit('loadingAggregatedStatsUruchomienia');

    try {
        const aggregatedStatsUruchomienia = await StatsUruchomieniaService.getAggregatedBetweenDates(1, 20, moment(store.state.aggregatedStatsUruchomieniaDateTo).subtract(20, "days").format('YYYY-MM-DD'), store.state.aggregatedStatsUruchomieniaDateTo, false, forceRefresh);
        const transformedStats = transformAggregatedStatsUruchomieniaResults(store.state.aggregatedStatsUruchomieniaDateTo, aggregatedStatsUruchomienia.data.data);
        const dataset = {
            label: 'Obecny rok',
            backgroundColor: 'rgba(63,81,181,0.6)',
            borderColor: '#3F51B5',
            borderWidth: 1,
            pointBackgroundColor: 'white',
            data: Object.values(transformedStats)
        };
        store.commit('loadedAggregatedStatsUruchomieniaDataset', {stat: dataset, updatedAt: aggregatedStatsUruchomienia.updatedAt.date});
        if (!_.isEmpty(store.state.aggregatedStatsUruchomieniaLastYearDataset)) {
            const datasets = {
                labels: Object.keys(transformedStats),
                datasets: [store.state.aggregatedStatsUruchomieniaDataset, store.state.aggregatedStatsUruchomieniaLastYearDataset]
            };
            store.commit('setAggregatedStatsUruchomieniaDatasets', datasets);
        }
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getAggregatedStatsUruchomieniaLastYear(store: ActionContext<State, any>, forceRefresh: boolean = false) {
    store.commit('loadingAggregatedStatsUruchomieniaLastYear');

    try {
        const aggregatedStatsUruchomieniaLastYear = await StatsUruchomieniaService.getAggregatedBetweenDates(1, 20, moment(store.state.aggregatedStatsUruchomieniaDateTo).subtract(1, "years").subtract(20, "days").format('YYYY-MM-DD'), moment(store.state.aggregatedStatsUruchomieniaDateTo).subtract(1, "years").format('YYYY-MM-DD'), true, forceRefresh);
        const transformedStats = transformAggregatedStatsUruchomieniaResults(store.state.aggregatedStatsUruchomieniaDateTo, aggregatedStatsUruchomieniaLastYear.data.data, true);
        const dataset = {
            label: 'Ubiegły rok',
            backgroundColor: 'rgba(207,216,220,0.6)',
            borderColor: '#CFD8DC',
            borderWidth: 1,
            pointBackgroundColor: 'white',
            data: Object.values(transformedStats)
        };
        store.commit('loadedAggregatedStatsUruchomieniaLastYearDataset', {stat: dataset, updatedAt: aggregatedStatsUruchomieniaLastYear.updatedAt.date});
        if (!_.isEmpty(store.state.aggregatedStatsUruchomieniaDataset)) {
            const datasets = {
                labels: Object.keys(transformedStats),
                datasets: [store.state.aggregatedStatsUruchomieniaDataset, store.state.aggregatedStatsUruchomieniaLastYearDataset]
            };
            store.commit('setAggregatedStatsUruchomieniaDatasets', datasets);
        }
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function loadPreviousAggregatedStatsUruchomienia(store: ActionContext<State, any>) {
    store.commit('loadPreviousAggregatedStatsUruchomienia', moment(store.state.aggregatedStatsUruchomieniaDateTo).subtract(20, "days").format('YYYY-MM-DD'));
    store.dispatch('getAggregatedStatsUruchomienia');
    store.dispatch('getAggregatedStatsUruchomieniaLastYear');
}

export async function loadNextAggregatedStatsUruchomienia(store: ActionContext<State, any>) {
    store.commit('loadNextAggregatedStatsUruchomienia', moment(store.state.aggregatedStatsUruchomieniaDateTo).add(20, "days").format('YYYY-MM-DD'));
    store.dispatch('getAggregatedStatsUruchomienia');
    store.dispatch('getAggregatedStatsUruchomieniaLastYear');
}

export async function refreshAggregatedStatsUruchomienia(store: ActionContext<State, any>) {
    store.commit('refreshingAggregatedStatsUruchomienia');
    store.dispatch('getAggregatedStatsUruchomienia', true);
    store.dispatch('getAggregatedStatsUruchomieniaLastYear', true);
}

function transformAggregatedStatsUruchomieniaResults(aggregatedStatsUruchomieniaDateTo: string, result :any, lastYear: boolean = false) {
    let resTransformed : any = [];
    let year :string = (lastYear) ? moment(aggregatedStatsUruchomieniaDateTo).subtract(1, "year").format('YYYY-MM-DD') : aggregatedStatsUruchomieniaDateTo;
    for(let i: number = 19; i>=0; i--) {
        let dateKey = moment(year).subtract(i, "days").format('YYYY-MM-DD');
        let foundInResult : any = _.find(result, {data:dateKey});
        resTransformed[moment(dateKey).format("D MMM")] = (foundInResult == undefined) ? 0 : foundInResult.ilosc;
    }
    return resTransformed;
}


export async function getStatsTopOperatingSystems(store: ActionContext<State, any>, forceRefresh: boolean = false) {
    store.commit('loadingStatsTopOperatingSystems');

    try {
        const statsTopOperatingSystems = await StatsTopService.getTopOperatingSystems(forceRefresh);
        const transformedStats = transformStatsTopOperatingSystemsResults(statsTopOperatingSystems.data);
        const dataset = {
            labels: Object.keys(transformedStats),
            datasets: [{
                label: 'Systemy operacyjne',
                backgroundColor: ['rgba(0,96,100,0.6)', 'rgba(183,28,28,0.6)', 'rgba(49,27,146,0.6)', 'rgba(255,111,0,0.6)', 'rgba(38,50,56,0.6)', 'rgba(21,101,192,0.6)', 'rgba(37,93,0,0.6)'],
                borderColor: ['#006064', '#b71c1c', '#311b92', '#ff6f00', '#263238', '#1565c0', '#255d00'],
                borderWidth: 1,
                pointBackgroundColor: 'white',
                data: Object.values(transformedStats)
            }]
        };
        store.commit('loadedStatsTopOperatingSystemsDataset', {stat: dataset, updatedAt: statsTopOperatingSystems.updatedAt.date});
        return true;
    }
    catch (error) {
        return false;
    }
}

function transformStatsTopOperatingSystemsResults(result :any) {
    let resTransformed : any = [];
    _.forEach(result, function(value) {
        resTransformed[value.os] = value.count;
    });
    return resTransformed;
}

export async function refreshStatsTopOperatingSystems(store: ActionContext<State, any>) {
    store.commit('refreshingStatsTopOperatingSystems');
    store.dispatch('getStatsTopOperatingSystems', true);
}

export async function getStatsTopBrowsers(store: ActionContext<State, any>, paginator: DataTablePaginator) {
    store.commit('setPageStatsTopBrowsers', paginator.page);
    store.commit('loadingStatsTopBrowsers');

    try {
        const statsTopBrowsers = await StatsTopService.getTopBrowsers(paginator.page, paginator.itemsPerPage);
        store.commit('loadedStatsTopBrowsers', {data: statsTopBrowsers.data, currentPage: statsTopBrowsers.meta.current_page, total: statsTopBrowsers.meta.total});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getStatsTopBrowsersAggregated(store: ActionContext<State, any>) {
    store.commit('loadingStatsTopBrowsersAggregated');

    try {
        const statsTopBrowsersAggregated = await StatsTopService.getTopBrowsersAggregated();
        store.commit('loadedStatsTopBrowsersAggregated', {data: statsTopBrowsersAggregated});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getStatsTopIP(store: ActionContext<State, any>, paginator: DataTablePaginator) {
    store.commit('setPageStatsTopIP', paginator.page);
    store.commit('loadingStatsTopIP');

    try {
        const statsTopIP = await StatsTopService.getTopIP(paginator.page, paginator.itemsPerPage);
        store.commit('loadedStatsTopIP', {data: statsTopIP.data, currentPage: statsTopIP.meta.current_page, total: statsTopIP.meta.total});
        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getStatsTopPobraniaReferers(store: ActionContext<State, any>, paginator: DataTablePaginator) {
    store.commit('setPageStatsTopPobraniaReferers', paginator.page);
    store.commit('loadingStatsTopPobraniaReferers');
    try {
        const statsTopPobraniaReferers = await StatsTopService.getTopPobraniaReferers(paginator.page, paginator.itemsPerPage);
        store.commit('loadedStatsTopPobraniaReferers', {data: statsTopPobraniaReferers.data, currentPage: statsTopPobraniaReferers.current_page, total: statsTopPobraniaReferers.total});
        return true;
    }
    catch (error) {
        return false;
    }
}


export default <ActionTree<State, any>> {
    getTotalStatsDeklaracje,
    refreshTotalStatsDeklaracje,
    getTotalStatsPobrania,
    refreshTotalStatsPobrania,
    getTotalStatsUruchomienia,
    refreshTotalStatsUruchomienia,
    getTotalStatsDeklaracjeLastYear,
    refreshTotalStatsDeklaracjeLastYear,
    getAggregatedStatsDeklaracje,
    getAggregatedStatsDeklaracjeLastYear,
    loadPreviousAggregatedStatsDeklaracje,
    loadNextAggregatedStatsDeklaracje,
    refreshAggregatedStatsDeklaracje,
    getAggregatedStatsUruchomienia,
    getAggregatedStatsUruchomieniaLastYear,
    loadPreviousAggregatedStatsUruchomienia,
    loadNextAggregatedStatsUruchomienia,
    refreshAggregatedStatsUruchomienia,
    getStatsTopOperatingSystems,
    refreshStatsTopOperatingSystems,
    getStatsTopBrowsers,
    getStatsTopBrowsersAggregated,
    getStatsTopIP,
    getStatsTopPobraniaReferers
}
